(function () {
// Trap Focus
function $142aec2eecb78988$var$trapFocus(element, excludingIn) {
    var KEYCODE_TAB = 9;
    element.addEventListener("keydown", function(e) {
        var isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;
        if (!isTabPressed) return;
        var focusableEls = Array.from(element.querySelectorAll("a[href]:not(" + excludingIn + " a), button:not(" + excludingIn + " textarea):not([disabled]), .tabs a:not(" + excludingIn + ' a):not(.tabs a[aria-selected="false"]):not([disabled]), textarea:not(' + excludingIn + ' textarea):not([disabled]), input[type="text"]:not(' + excludingIn + ' input):not([disabled]), input[type="radio"]:not(' + excludingIn + ' input):not([disabled]), input[type="checkbox"]:not(' + excludingIn + ' input):not([disabled]), input[type="search"]:not(' + excludingIn + ' input):not([disabled]), input[type="submit"]:not(' + excludingIn + " input):not([disabled]), select:not(" + excludingIn + " select):not([disabled])"));
        if (focusableEls[0].classList.contains("back-button") && !focusableEls[0].classList.contains("active")) focusableEls.shift();
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        if (e.shiftKey) {
            if (document.activeElement === firstFocusableEl) {
                e.preventDefault();
                lastFocusableEl.focus();
            }
        } else if (document.activeElement === lastFocusableEl) {
            e.preventDefault();
            firstFocusableEl.focus();
        }
    });
}
document.addEventListener("DOMContentLoaded", function() {
    var _loop = function(i) {
        var video = videoBlocks[i];
        var button = video.querySelector(".content-media__video-button ");
        var closeButton = video.querySelector(".content-media__close-player");
        var videoPlayer = video.querySelector(".content-media__video-player");
        button.addEventListener("click", function() {
            video.classList.add("content-media--playing");
            $142aec2eecb78988$var$trapFocus(videoPlayer);
            button.setAttribute("aria-expanded", true);
            closeButton.setAttribute("aria-expanded", true);
            videoPlayer.setAttribute("aria-hidden", false);
            setTimeout(function() {
                closeButton.focus();
            }, 50);
        });
        closeButton.addEventListener("click", function() {
            video.classList.remove("content-media--playing");
            button.setAttribute("aria-expanded", false);
            closeButton.setAttribute("aria-expanded", false);
            videoPlayer.setAttribute("aria-hidden", true);
            setTimeout(function() {
                button.focus();
            }, 50);
        });
    };
    // Variables
    var videoBlocks = document.querySelectorAll(".content-media__media-video");
    for(var i = 0; i < videoBlocks.length; i++)_loop(i);
});

})();
//# sourceMappingURL=content-media.js.map
